export const lang = {
  en: {
    'Personal Data': 'victim’s bio',
    Religion: 'Religion',
    Occupation: 'Occupation',
    Education: 'Education',
    Gender: 'Gender',
    'Crime Data': 'Incident data',
    'Threats or failed attempts': 'Threats or failed attempts',
    'Modes of killing': 'Modes of killing',
    Legal: 'Legal Process',
    Arrests: 'Arrests',
    Prosecution: 'Prosecution',
    'Filter Map': 'Filter Map',
    All: 'ALL',
    EJK: 'Extrajudicial Killing',
    'Attempts/Threats': 'Attempts/Threats',
    'click on dot': 'hover or click on dot for more information',
    'how to': 'how to read the map',
    Donate: 'Donate',
    Copyright: 'Copyright',
    ABC: 'Abdorrahman Boroumand Center',
    Title: 'Iran: State Violence Beyond Borders',
    Subtitle: "Borders didn't confine the State from Silencing these people",
    Read: 'Read More',
    Quantity: 'extrajudicial killings over',
    Years: 'years',
    Explore: 'Explore data on map',
    Contribute: 'Contribute to our work and history',
    Add: 'Add to the database',
    Loading: 'Loading...',
    Error: 'Error. Please try again.',
    Date: 'Date',
    Location: 'Location',
    'click to read': 'click to read more',
    DateKilling: 'Date of Killing',
    LocationKilling: 'Location of Killing',
    DateThreat: 'Date of Threat(s)',
    LocationThreat: 'Location of Threat',
    EJKLocation: 'violations in this location',
    Violation: 'violation',
    Violations: 'violations',
    Victim: 'victim',
    Victims: 'victims',
    InLocation: 'in this location',
    'click to see': 'click to see list of cases',
    UnknownPerson: 'Unknown',
    Unknown: 'Unknown',
    Age: 'Age',
    Nationality: 'Nationality',
    Complete: 'correct or complete entry',
    'click on name': 'click on a name to read more',
    NoInfo: 'No information available',
    SelectYear: 'Select a year',
    AllYears: 'All Years',
    Apply: 'Apply',
    FiltersApplied: 'Filters applied',
    Abdorrahman: 'Abdorrahman',
    Boroumand: 'Boroumand Center',
    HumanRights: 'for Human Rights in Iran',
    Memorial: 'Memorial',
    Library: 'Library',
    Projects: 'Projects',
    About: 'About',
    News: 'News',
    Logo: 'Logo',
    SupplementaryDocumentation: 'Supplementary Documentation',
    Back: 'back to timeline',
    Share: 'Share',
    Enter: 'Type to select a name',
    //LoadingSearch: 'loading search...',
    ErrorSearch: 'Error loading search.',
    Comma: ',',
    Showing: 'Showing',
    AddToMap: 'Add to the Map',
    Fatal: 'instances of extrajudicial killing',
    NonFatal: 'instances of threats/attempts',
    AtLeast: 'At least',
    Exclude: '(To exclude killings or threats/attempts, set filter to “none”)',
    Intro1:
      'Since February 1979, agents and proxies of the Islamic Republic of Iran have kidnapped, disappeared, and extrajudicially executed (both inside and outside Iran) a significant number of individuals whose activities and influence they deemed undesirable. The involvement of Iran’s authorities, diplomats and security forces in ordering, planning, and carrying out these crimes has been laid bare, and sometimes acknowledged by Iranian officials, in multiple cases. In the absence of transparency, systematic official investigations and independent field research, the actual number of the victims of these crimes – numbering at least 452 outside Iran alone, remains unknown.',
    Intro2:
      'In Iran, perpetrators have benefited from impunity and calls for truth and justice have often been punished. The states on whose territory these crimes were committed have too often failed their duty to protect victims’ right to life and justice. They have denied victims and the public access to relevant and accurate information, a prerequisite for ensuring meaningful accountability and essential to the rule of law and non-repetition. In many cases, invoking national security or prioritizing political and economic interests, host countries have avoided making arrests, allowed arrested suspects - in particular state agents - to leave, granted early releases to those convicted for these crimes, or depoliticized the killings by prosecuting them as ordinary crimes. These policies have strengthened a culture of impunity and opened the way to the repetition of these crimes and made Iran’s sinister warnings more effective in silencing dissent.',
    Intro3:
      'Through this map, Abdorrahman Boroumand Center (ABC) for Human Rights in Iran aims to shed light on the extrajudicial killings attributed to Iran or its proxies, in support of victims’ and society’s right to the truth and accountability. The visualized data, though representing only a portion of actual cases, allows a better understanding of the killings’ frequency, scope, geographical extent, and of the ensuing judicial process, if any. The map also aims to provide a better understanding of the nature and scope of failed assassination and kidnapping attempts as well as death threats that are transmitted to targeted individuals directly or through others, digitally, and by phone and social media among other means. These underreported and often overlooked warnings, which often precede physical eliminations inside and outside Iran, have a significant and negative impact on the lives of the individuals targeted, their family members and the community at large. They also undermine the exercise of fundamental rights such as the right to freedom of speech, association, religion, and assembly with no consequences for their perpetrators.'
  },
  fa: {
    'Personal Data': 'اطلاعات قربانی',
    Religion: 'مذهب',
    Occupation: 'شغل',
    Education: 'تحصیلات',
    Gender: 'جنسیت',
    'Crime Data': 'داده‌های واقعه',
    'Threats or failed attempts': 'تهدید یا ترور ناموفق',
    'Modes of killing': 'نحوه قتل فراقضایی',
    Legal: 'روند قضایی',
    Arrests: 'دستگیری',
    Arrested: 'فرد یا افرادی بازداشت شدند',
    'Not Arrested': 'فرد یا افرادی بازداشت نشدند',
    Prosecution: 'روند قضایی',
    Prosecuted: 'دادگاهی تشکیل شد',
    'Not Prosecuted': 'دادگاهی تشکیل نشد',
    'Filter Map': 'فیلتر نقشه',
    All: 'همه',
    None: 'هیچ کدام',
    EJK: 'قتل فراقضایی',
    'Attempts/Threats': 'ترور ناموفق/ تهدید',
    'click on dot': 'برای اطلاعات بیشتر روی نقطه کلیک کنید',
    'how to': 'نحوه استفاده از نقشه',
    Donate: 'کمک مالی',
    Copyright: 'حق تألیف و تکثیر',
    ABC: 'بنیاد عبدالرحمن برومند',
    Title: 'ایران: خشونت دولتی بدون مرز',
    Subtitle: 'مرزها مانع کشتن‌شدن این افراد توسط دولت نشد',
    Read: 'بیشتر بخوانید',
    Quantity: 'قتل فراقضایی در',
    Years: 'سال',
    Explore: 'جستجوی داده‌ها بر روی نقشه',
    Contribute: 'با یاری به ما در ثبت تاریخ مشارکت کنید',
    Add: 'به پایگاه داده‌ها اضافه کنید',
    Loading: 'بارگذاری',
    Error: 'خطا! لطفا دوباره تلاش کنید.',
    Date: 'تاریخ',
    Location: 'محل',
    'click to read': 'برای خواندن ادامه مطلب اینجا کلیک کنید',
    DateKilling: 'تاریخ قتل',
    LocationKilling: 'محل کشته شدن',
    DateThreat: 'تاریخ تهدید(ها)',
    LocationThreat: 'محل تهدید',
    EJKLocation: 'مورد نقض حقوق بشر در این مکان',
    Violation: 'نقض حقوق بشر',
    Violations: 'نقض حقوق بشر',
    Victim: 'قربانی',
    Victims: 'قربانی',
    InLocation: 'در این مکان',
    'click to see': 'برای مشاهده لیست افراد اینجا کلیک کنید',
    UnknownPerson: 'ناشناس',
    Unknown: 'نامعلوم',
    Age: 'سن',
    Nationality: 'ملیت',
    Complete: 'تصحیح یا تکمیل کنید',
    'click on name': 'برای خواندن ادامه مطلب روی نام کلیک کنید',
    NoInfo: 'هیچ اطلاعی در دسترس نیست',
    SelectYear: 'انتخاب سال',
    AllYears: 'همه سال‌ها',
    Apply: 'اعمال کن',
    FiltersApplied: 'فیلترهای اعمال شده',
    Abdorrahman: 'بنیاد',
    Boroumand: 'عبدالرحمن برومند',
    HumanRights: 'برای حقوق بشر در ایران',
    Memorial: 'یادبود',
    Library: 'کتابخانه',
    Projects: 'ویژه‌ها',
    About: 'درباره ما',
    News: 'خبرها',
    Logo: 'لوگو',
    SupplementaryDocumentation: 'مستندات تکمیلی',
    Back: 'بازگشت به جدول زمانی',
    Share: 'اشتراک گذاری',
    Enter: 'برای انتخاب نام تایپ کنید',
    //LoadingSearch: 'yyy...',
    ErrorSearch: 'خطا در بارگیری جستجو',
    Comma: '،',
    Showing: 'نشان دادن',
    AddToMap: 'تکمیل اسامی',
    Fatal: 'مورد قتل فراقضایی',
    NonFatal: 'مورد ترور ناموفق/ تهدید',
    AtLeast: 'دستکم',
    Exclude: '(برای حذف قتل یا تهدید/تلاش، فیلتر را روی «هیچ» تنظیم کنید)',
    Intro1:
      'از بهمن ماه سال ۱۳۵۷ تا به امروز، تعداد بیشماری از افرادی که فعالیت‌ها و نفوذشان از دید جمهوری اسلامی ایران نامطلوب و غیر قابل قبول بوده، توسط ماموران و عوامل این نظام (هم در خاک ایران و هم در خارج از کشور) ربوده، ناپدید، و یا اعدام فراقضایی شده‌اند. دست داشتن مقامات، دیپلمات‌ها، و نیروهای امنیتی ایران در صدور دستورِ اجرا، برنامه‌ریزی، و ارتکاب این جنایات نه تنها به اثبات رسیده بلکه بعضاً از سوی مقامات ایران در موارد متعدد تایید نیز شده است. در نبود شفافیت، تحقیقات روشمندِ رسمی، و پژوهش‌های میدانی مستقل، شمار دقیق قربانیان این جرایم، که فقط در خارج از ایران به دست‌کم ۴۵۲ تن می‌رسد، مشخص نیست.',
    Intro2:
      'در ایران، مرتکبین این جنایات از مجازات مصون مانده و در عوض، آنهایی که خواستار کشف حقیقت و اجرای عدالت بوده‌اند، مجازات شده‌اند. کشورهایی که این جنایات در خاکشان اتفاق افتاده، در بسیاری از موارد در اجرای وظایف خود مبنی بر حفاظت از حق حیاتِ قربانیان و حق برخورداری از عدالت، قصور کرده‌اند. این کشورها، دسترسی عموم و نیز قربانیان به اطلاعات صحیح –  اطلاعاتی که لازمه تضمین پاسخگویی بوده و جهت اجرای حاکمیت قانون و عدم تکرار جرم، واجب و ضروری است –  را از آنان دریغ کرده‌اند و در بسیاری از موارد، با استناد به موضوعاتی نظیر امنیت ملی یا اولویت منافع سیاسی و اقتصادی، از دستگیری مظنونین خودداری کرده‌اند، به متهمان دستگیر شده – علی‌الخصوص ماموران دولتی – اجازه داده‌اند از کشور خارج شوند، مجرمانی که به لحاظ ارتکاب این جنایات محکوم شده‌اند را پیش از موعد آزاد کرده‌اند، و یا این که از طریق محاکمه مرتکبینِ این جرایم تحت عنوان جرایم عادی، این قتل‌ها راغیر سیاسی جلوه داده‌اند. اجرا و ادامه این سیاست‌ها باعث شده تفکر مصونیت از مجازات در میان مرتکبین شدت گرفته ، راه برای تکرار این جنایات باز شود، و هشدارهای اهریمنی حکومت ایران برای خاموش کردن صدای معترضان نیز موثرتر واقع شود.',
    Intro3:
      'هدف بنیاد عبدالرحمن برومند برای دموکراسی و حقوق بشر در ایران (بنیاد، بنیاد برومند) از تهیه این نقشه این است که در حمایت از حق قربانیان و جامعه مبنی بر دانستن حقیقت و پاسخگویی مرتکبین، قتل‌های فراقضایی منسوب به ایران و یا عوامل آن را در معرض دید همگان قرار دهد. این داده‌های بصری، اگرچه تنها بخشی از موارد را به نمایش می‌گذارد، با این حال به درک بهترِ تناوب، گستره، قلمرو جغرافیایی، و دادرسی قضایی (در صورتی که دادرسی‌ای در کار بوده باشد) کمک می‌کند. نقشه حاضر همچنین در صدد برآمده درک بهتری از ماهیت و گستره ترورهای ناموفق و اقدامات انجام گرفته در جهت شروع به آدم‌ربایی، ارائه دهد، و نیز موارد تهدید به مرگِ افراد خاص، تهدیداتی که به طور مستقیم یا از طریق دیگران، اینترنت، تلفن و یا شبکه‌های اجتماعی به آنان منتقل می‌شود را به نمایش گذارد. این هشدارها که کمتر گزارش شده و یا نادیده گرفته می‌شوند، و اغلب پیش درآمدی بر حذف فیزیکی افراد در داخل و خارج از ایران هستند، تاثیر منفی قابل توجهی بر زندگی افرادی که هدف قرار گرفته‌اند و خانواده‌هایشان، و کلاً بر جامعه، بر جای می‌گذارد. این تهدیدات همچنین بهره‌مند شدن از حقوق بنیادین بشر، نظیر آزادی بیان، ارتباطات، مذهب، و اجتماعات را بدون کوچک‌ترین عواقب منفی‌ای برای مرتکبین، به خطر انداخته و تضعیف می‌کند.'
  }
}
